<template>
  <section class="ratings">
    <div class="ratings__content">
      <div class="title">12 450+</div>
      <div class="caption">{{ $t("subscriptions.ratings.caption") }}</div>

      <div class="store-container-wrapper">
        <div class="store-container">
          <div class="card">
            <div class="title">
              4,90<img :src="`${mediaBaseUrl}subscriptions/app-store.png`" class="icon" />
            </div>
            <div class="stars">
              <img :src="`${mediaBaseUrl}subscriptions/star.svg`" />
              <img :src="`${mediaBaseUrl}subscriptions/star.svg`" />
              <img :src="`${mediaBaseUrl}subscriptions/star.svg`" />
              <img :src="`${mediaBaseUrl}subscriptions/star.svg`" />
              <img :src="`${mediaBaseUrl}subscriptions/star.svg`" />
            </div>
            <div class="text">App Store</div>
          </div>
          <div class="card">
            <div class="title">
              4,85<img :src="`${mediaBaseUrl}subscriptions/play-store.png`" class="icon" />
            </div>
            <div class="stars">
              <img :src="`${mediaBaseUrl}subscriptions/star.svg`" />
              <img :src="`${mediaBaseUrl}subscriptions/star.svg`" />
              <img :src="`${mediaBaseUrl}subscriptions/star.svg`" />
              <img :src="`${mediaBaseUrl}subscriptions/star.svg`" />
              <img :src="`${mediaBaseUrl}subscriptions/star.svg`" />
            </div>
            <div class="text">Play Store</div>
          </div>
        </div>
        <div class="branches-container">
          <div class="image">
            <img :src="`${mediaBaseUrl}subscriptions/branches.png`" />
          </div>
          <div class="text">
            <span class="bold">{{ $t("subscriptions.ratings.bold") }}</span>
            {{ $t("subscriptions.ratings.text") }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  inject: ["mediaBaseUrl"],
};
</script>

<style scoped lang="sass">
$lg: 700px

.ratings
  width: 100%
  display: flex
  flex-direction: column
  align-items: center
  padding-bottom: 35px !important

  &__content
    display: flex
    padding: 28px 21px 37px
    background: #FCF3FF
    border-radius: 16px
    flex-direction: column

    @media screen and (min-width: $lg)
      max-width: 1037px
      width: 100%

    .title
      font-size: 40px
      font-weight: 700
      line-height: 56px
      text-align: center
      color: #1B2A3F

    .caption
      font-size: 18px
      font-weight: 400
      line-height: 25.2px
      text-align: center
      color: #1B2A3F
      margin-bottom: 24px

    .store-container-wrapper
      display: flex
      flex-direction: column

      @media screen and (min-width: $lg)
        justify-content: center
        gap: 36px
        flex-direction: row

    .store-container
      display: flex
      gap: 16px
      justify-content: space-between

      @media screen and (min-width: $lg)
        gap: 48px
        padding: 7px 0

      .card
        padding: 14px 12px
        gap: 4px
        border-radius: 16px
        background: #FFFFFF
        padding: 14px 12px
        display: flex
        flex-direction: column
        gap: 4px
        align-items: center
        justify-content: center

        .title
          font-size: 24px
          font-weight: 700
          line-height: 33.6px
          text-align: center
          color: #1B2A3F
          display: flex
          align-items: center
          gap: 6px

          .icon
            width: 24px
            height: 24px
            object-fit: cover

        .text
          font-size: 14px
          font-weight: 400
          line-height: 19.6px
          text-align: center
          color: #1B2A3F

        .stars
          display: flex
          align-items: center
          justify-content: space-between
          gap: 4px

          img
            width: 20px
            height: 20px

    .branches-container
      width: 100%
      display: flex
      position: relative
      margin-top: 24px

      @media screen and (min-width: $lg)
        max-width: 334px

      .image
        width: 100%
        height: 100%
        object-fit: cover

        img
          width: 100%
          max-height: 125px

      .text
        font-size: 18px
        font-weight: 400
        line-height: 25.2px
        text-align: center
        color: #1B2A3F
        position: absolute
        width: 100%
        height: 100%
        top: 0
        display: flex
        align-items: center
        justify-content: center
        flex-direction: column

        .bold
          font-weight: 700
</style>
